<template>

<!--  <PriceDistance :tag="'td'" :symbol="row.symbol" :threshold="3" :previousClose="row.tradingData?.previousClose" :direction="'bottom'"-->
<!--                 :defaultPrice="row.tradingData?.price" :value="row.tradingData.fiftyTwoWeeksLow"-->
<!--                 @deltaChange="deltaChange(row.symbol, $event, '52wlD')"/>-->

  <td :dir="uiDirection">
    <PriceRange v-if="row.tradingData?.yearlyRange" :low="row.tradingData.fiftyTwoWeeksLow" :high="row.tradingData.fiftyTwoWeeksHigh" :value="row.tradingData?.yearlyRange"/>
  </td>

<!--  <PriceDistance :tag="'td'" :symbol="row.symbol" :threshold="3" :previousClose="row.tradingData?.previousClose" :direction="'top'"-->
<!--                 :defaultPrice="row.tradingData?.price" :value="row.tradingData.fiftyTwoWeeksHigh"-->
<!--                 @deltaChange="deltaChange(row.symbol, $event, '52whD')"/>-->

</template>

<script>
import PriceRange from "../priceTags/priceRange";
import PriceDistance from "../priceTags/priceDistance";
export default {
  name: "YearlyRangeCell",
  props: ['row', 'deltaChange'],
  components: {PriceDistance, PriceRange}
}
</script>

<style scoped lang="scss">

td {
  padding: 4px 8px !important;
  border-bottom: 1px solid var(--notficationBorderColor);
  width: auto;
  font-weight: 600;
  background: var(--bgColor);
  border-right: 1px solid var(--notficationBorderColor);
  div, span {

    font-size: 14px;
  }
  * {
    font-size: 14px;
  }
}

td[dir="rtl"] {
  border-right: unset;
  border-left: 1px solid var(--notficationBorderColor);
}

.sorted {
  box-sizing: content-box;
  border-left: 2px solid var(--highlightColor) !important;
  border-right: 2px solid var(--highlightColor) !important;
  background: var(--tableHoverColor);
}

.sorted.first-sorted {
  border-top: 2px solid var(--highlightColor) !important;
  overflow: hidden;
}

.sorted.last-sorted {
  border-bottom: 2px solid var(--highlightColor) !important;
}

.hoveredColumn {
  background: var(--tableHoverColor) !important;
}
</style>
